module.exports = __webpack_public_path__ + "static/formation-utilisation-de-votre-site-internet-dc675c27e1476d1e951601e5611a8177.png";